/* eslint max-len: 0 quote-props: 0 */

export default {
    modal: {
        'close': '關閉',
    },
    login: {
        'loading': '正在載入',
        'modalLabelUsername': '账户名称',
        'modalLabelPassword': '密码',
        'modalLabelRememberUsername': '保存账户名称',
        'modalLabelKeepMeLoggedIn': '保持账户登陆状态',
        'modalLoginButtonText': '登陆',
        'modalForgotPassword': '忘記登入信息?',
        'modalRegisterText': '尚未拥有账户？',
        'modalRegisterLink': '马上注册',
        'modalValidatorUsernameRequired': '请填写账户名称',
        'modalValidatorUsernameFormat': '账户名称只允许使用英文字母、数字和下划线',
        'modalValidatorUsernameTooShort': '账户名称必须至少包含6个字符',
        'modalValidatorUsernameTooLong': '账户名称不能超过15个字符',
        'modalValidatorPasswordRequired': '请填写密码',
        'modalValidatorPasswordFormat': '密码只允许使用英文字母、数字、连字符和下划线',
        'modalValidatorPasswordTooShort': '密码必须至少包含6个字符',
        'modalValidatorPasswordTooLong': '密码不能超过15个字符',
        'modalErrorInitFormLine1': '某些地方出错了',
        'modalErrorInitFormLine2': '请稍后重试一次…',
        'modalErrorAuthDefaultLine1': '某些地方出错了',
        'modalErrorAuthDefaultLine2': '我们无法处理您的信息，请重试一次。',
        'modalErrorAuthCredentialsBadLine1': '很抱歉，您輸入的賬戶名稱/密碼不正確。',
        'modalErrorAuthCredentialsBadLine2': '請重試一次或<RecoverAccountComponent>點擊這裡</RecoverAccountComponent>恢復您的賬戶。',
        'modalErrorAuthSelfExcludedLine1': '您已經申請了對您的賬戶進行自我排除。',
        'modalErrorAuthSelfExcludedLine2': '請<a href="{showHelp__(6515)}">點擊這裡</a>查看關於博彩責任的信息。',
        'modalErrorAuthLockedLine1': '很抱歉，您的賬戶出現了問題。',
        'modalErrorAuthLockedLine2': '請<a href="{launchLiveChat__(chat_err:++:OB_ERR_CUST_ACCT_LOCKED)}">點擊這裡</a>啟動綫上客服聯絡我們的客戶服務部。',
        'modalErrorAuthInactiveLine1': '很抱歉，您的賬戶出現了問題。',
        'modalErrorAuthInactiveLine2': '請<a href="{showHelp__(6557)}">點擊這裡</a>聯絡我們的客戶服務部以尋求幫助。',
        'modalErrorAuthClosedLine1': '很抱歉，您無法登入您的賬戶。',
        'modalErrorAuthClosedLine2': '請<a href="{showHelp__(6557)}">點擊這裡</a>聯絡我們的客戶服務部以尋求幫助。',
        'modalErrorAuthAgeVerificationLine1': '很抱歉，您需要完成年齡證明驗證程式。',
        'modalErrorAuthAgeVerificationLine2': '請<a href="{ageVerification}">點擊這裡</a>進行驗證。',
        'modalErrorAuthClosedByPlayerLine1': '很抱歉，您的賬戶已經被關閉。',
        'modalErrorAuthClosedByPlayerLine2': '請 <a href="{reopenAccount}">點擊這裡</a>重開您的賬戶或<a href="{showHelp__(6557)}">聯絡我們的客戶服務部</a>。',
        'modalErrorAuthSelfExcludedFinishedLine1': '賬戶已經被自我排除，您可以重新激活這個賬戶。',
        'modalErrorAuthSelfExcludedFinishedLine2': '請<a href="{showHelp__(6557)}">點擊這裡</a>聯絡我們的客戶服務部以重開賬戶。',
        'modalErrorAuthTimeoutLine1': '您的賬戶已經被短期暫停，因此您目前無法登入您的賬戶。短期暫停賬戶會在{date}的{time}結束。之後您就能重新登入你的賬戶。',
        'modalErrorAuthTimeoutLine2': '請<a href="{showHelp__(6515)}">點擊這裡</a>查看關於博彩責任的信息。',
        'modalErrorAuthOxiErrorLine1': '很抱歉，在登入時出現錯誤，請重試一次。',
        'modalErrorAuthOxiErrorLine2': '如果這個問題持續出現，請<a href="{showHelp__(6557)}">點擊這裡</a>聯絡我們的客戶服務部以尋求幫助。',
        'modalErrorAuthRestrictedLine1': '您的賬戶已經被凍結。',
        'modalErrorAuthRestrictedLine2': '請<a href="{showHelp__(6557)}">點擊這裡</a>聯絡我們的客戶服務部以尋求幫助。',
        'modalErrorAuthMaxLoginAttemptsLine1': '您似乎在登入時遇到了問題',
        'modalErrorAuthMaxLoginAttemptsLine2': '- 請<RecoverAccountComponent>點擊這裡</RecoverAccountComponent>恢復您的賬戶。',
        'modalErrorAuthMaxLinkedAccountsLine1': '您似乎已經擁有了一個William Hill賬戶。',
        'modalErrorAuthMaxLinkedAccountsLine2': '根據我們的條款規定，每位客戶只能擁有一個賬戶。請登入您當前的賬戶。如果您遺失了登入資料，您可以點擊<RecoverAccountComponent>這裡</RecoverAccountComponent>找回，或聯絡我們的<a href="{showHelp__(6557)}">客戶服務部</a>。',
    },
};



// WEBPACK FOOTER //
// ./src/main/translations/zh-hk.js